import apiClient from '../../shared/auth/services'

// Helper function to make API calls
const apiCall = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.post(endpoint, data)
    return response.data
  } catch (error) {
    console.error(`API call failed for ${endpoint}:`, error)
    throw error
  }
}

export const shareService = {
  // Get share information
  getShareInfo: (shareCode) => apiCall('/getShareInfo', { shareCode }),
  
  // Get object data for share
  getObject: (objectId, satsueiMemoCategoryId, isShareFlg, sharePixId) => 
    apiCall('/getObject', { objectId, satsueiMemoCategoryId, isShareFlg, sharePixId }),
  
  // Get object count for share
  getObjectCount: (objectId, isShareFlg, sharePixId) => 
    apiCall('/getObjectCount', { objectId, isShareFlg, sharePixId }),
  
  // Get satsuei memo category for share
  getSatsueiMemoCategory: (isContainSatsueiMemoColumn = false, isShareFlg = true, sharePixId) => 
    apiCall('/getSatsueiMemoCategory', { isContainSatsueiMemoColumn, isShareFlg, sharePixId }),
  
  // Get satsuei guide list for share
  getSatsueiGuideList: (satsueiMemoCategoryId, isShareFlg = true, sharePixId) => 
    apiCall('/getSatsueiGuideList', { satsueiMemoCategoryId, isShareFlg, sharePixId }),
  
  // Get satsuei memo form for share
  getSatsueiMemoForm: (objectId, satsueiMemoCategoryId, changeSatsueiMemoFlg = false, isShareFlg = true, sharePixId) => 
    apiCall('/getSatsueiMemoForm', { objectId, satsueiMemoCategoryId, changeSatsueiMemoFlg, isShareFlg, sharePixId }),
  
  // Get image folder list for share
  getImageFolderList: (objectId, isContainMishitei = true, isShareFlg = true, sharePixId) => 
    apiCall('/getImageFolderList', { objectId, isContainMishitei, isShareFlg, sharePixId }),
  
  // Get image list for share
  getImageList: (objectId, isShareFlg = true, sharePixId) => 
    apiCall('/getObjectImageList', { objectId, isShareFlg, sharePixId }),
  
  // Get movie list for share
  getMovieList: (objectId, isShareFlg = true, sharePixId) => 
    apiCall('/getMovieList', { objectId, isShareFlg, sharePixId }),
  
  // Get object list download for share
  getObjectListDownload: async (satsueiMemoCategoryId, objectId, isShareFlg = true, sharePixId) => {
    try {
      const response = await apiClient.post('/getObjectListDownload', {
        satsueiMemoCategoryId,
        objectId,
        isShareFlg,
        sharePixId
      }, {
        responseType: 'blob'
      })
      return response.data
    } catch (error) {
      console.error('Download failed for share:', error)
      throw error
    }
  },
  
  // Get image - returns blob data for proper cleanup
  // imageType: optional 'satsueiImage' for full image (e.g. carousel); default 'thumb_comp'
  getImage: async (objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded, isShareFlg = true, sharePixId, imageType) => {
    try {
      const type = imageType === 'satsueiImage' ? 'satsueiImage' : 'thumb_comp'
      const params = {
        objectId,
        objectImageId,
        objectImageEditId,
        filenameExtension,
        isUploaded: isUploaded !== null && isUploaded !== undefined ? isUploaded : false,
        type,
        isShareFlg: isShareFlg !== null && isShareFlg !== undefined ? isShareFlg : false,
        sharePixId: sharePixId !== null && sharePixId !== undefined ? sharePixId : '',
      }
      if (type !== 'satsueiImage') {
        params.width = 148
        params.height = 148
      }
      const response = await apiClient.get('/getImage', {
        params,
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      return response.data // Return blob data instead of URL
    } catch (error) {
      console.error('Failed to get image blob:', error)
      return null
    }
  },

  // Legacy method that returns URL (deprecated - use getImage with useBlobUrl hook instead)
  getImageUrl: async (objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded, isShareFlg = true, sharePixId) => {
    try {
      const response = await apiClient.get('/getImage', {
        params: {
          objectId,
          objectImageId,
          objectImageEditId,
          filenameExtension,
          isUploaded: isUploaded !== null && isUploaded !== undefined ? isUploaded : false,
          type: 'thumb_comp',
          isShareFlg: isShareFlg !== null && isShareFlg !== undefined ? isShareFlg : false,
          sharePixId: sharePixId !== null && sharePixId !== undefined ? sharePixId : '',
          width: 148,
          height: 148
        },
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      return URL.createObjectURL(response.data)
    } catch (error) {
      console.error('Failed to get image URL:', error)
      return null
    }
  },
  
  getMovie: (objectId, objectMovieId, filenameExtension) => {
    return apiClient.post('/movie', {
      objectId,
      objectMovieId,
      filenameExtension
    }, {
      responseType: 'blob',
    })
  },

  // Get movie URL for share
  getMovieUrl: (objectId, objectMovieId, filenameExtension, isShareFlg = true, sharePixId) => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/pix'
    return `${baseUrl}/movie.action?objectId=${objectId}&objectMovieId=${objectMovieId}&filenameExtension=${filenameExtension}&isShareFlg=${isShareFlg}&sharePixId=${sharePixId}`
  }
}
